<template>
  <div class="payBefore">
    <div class="main_wraper">
      <header>
        <p>{{$t('payBefore.pending')}}</p>
      </header>
      <section>
        <div class="product-card">
          <div class="product-card_top">
            <div class="shopName">
              <img :src="logo_url" alt="">
              <span>{{ shopname }}</span>
            </div>
            <div class="totalPrice">
              <p class="totalPrice_currency">{{$t('payBefore.totalPrice')}}</p>
              <p class="totalPrice_number">
                <span>{{currencyList[link_currency]}}</span>
                <span>{{ link_amt }}</span>
              </p>
            </div>
            <div class="product-detail">
              <div class="product-detail_message" v-for="item in related_goods" :key="item.id">
                <p>{{ item.name }}</p>
                <p v-if="inputStatus">{{currencyList[item.currency]}}{{item.singTotal}}</p>
                <p>x{{ item.goods_num }}</p>
                <p>{{ item.price }}</p>
              </div>
            </div>
          </div>
          <div class="product-card_bottom">
            <p>{{$t('payBefore.paymentClosingDate')}}</p>
            <p>{{ expire_time }}</p>
          </div>
        </div>

        <div class="customer-information">
          <p class="information">{{$t('payBefore.customerInformation')}}</p>
          <div class="telephone">
            <label for="phone">{{$t('payBefore.telephone')}}</label>
            <!-- pc端电话显示形式 -->
            <input type="text" v-if="inputStatus" maxlength="3" class="fe_pcInput" @blur="validTelephone()" v-model.trim="telephone1">
            <input type="text" v-if="inputStatus" id="phone" maxlength="20" :placeholder="$t('payBefore.placeholder.phone')" @blur="validTelephone()" v-model.trim="telephone2">
            <!-- 移动端电话显示形式 -->
            <div class="flex-row">
               <input type="text" v-if="!inputStatus" id="phone" maxlength="24" placeholder="e.g. 852-99999999" v-model.trim="telephone2" @blur="validTelephone()">
               <p v-if="telephoneStatus" class="error-message">{{ $t('payBefore.errorMessage.phone') }}</p>
               <p v-if="telephoneFormat" class="error-message">{{ $t('payBefore.errorMessage.phoneFormate') }}</p>
            </div>
          </div>
          <div class="name" :class="{'error-message': telephoneStatus}">
            <label for="na">{{$t('payBefore.name')}}</label>
            <div class="flex-row">
               <input type="text" id="na" :placeholder="$t('payBefore.placeholder.name')" v-model.trim="customerName" maxlength="20" @blur="validName()">
               <p v-if="nameFormat" class="error-message">{{ $t('payBefore.errorMessage.otherValid') }}</p>
            </div>
          </div>
          <div class="email">
            <label for="ema">{{$t('payBefore.mailbox')}}</label>
            <div class="flex-row">
              <input type="text" id="ema" v-model.trim="customerEmail" :placeholder="$t('payBefore.placeholder.email')" maxlength="50" @blur="validEmail">
              <p v-if="emailStatus" class="error-message">{{ $t('payBefore.errorMessage.invalidEmail') }}</p>
            </div>
          </div>
          <!-- pc端显示内容 -->
          <div class="someTips" v-if="!emailStatus && inputStatus">
            * {{$t('payBefore.mailboxTips')}}
          </div>
          <!-- 移动端显示内容 -->
          <div class="someTips" v-if="!inputStatus" :class="{'emailExtendHeight': emailStatus}">
            * {{$t('payBefore.mailboxTips')}}
          </div>
        </div>
        <!-- 移动端物流方式 -->
        <div class="logistics" :class="{'extendLogistics': textAreaStatus || textAreaStatusFormat}" v-if="!inputStatus && need_delivery === 1">
          <p class="logistics_top">{{$t('payBefore.logistics')}}</p>
          <div class="logistics_center">
            <div class="logistics_center_left">
              <div class="flex-row">
                <div class="flex-column">
                  <p>{{$t('payBefore.logisticsMode.title')}}</p>
                  <!-- 第一种：无物流方式 -->
                   <p v-if="delivery_type === 2">{{$t('payBefore.logisticsMode.mode3')}}</p>
                   <p v-if="delivery_type === 1">{{$t('payBefore.logisticsMode.mode4')}}</p>
                </div>
                <!-- 无物流方式 -->
                <!-- 第二种：寄送或者自取方式 -->
                <van-field
                  readonly
                  clickable
                  name="picker"
                  v-model.trim="logist"
                  @click="showPicker = true"
                  v-if="delivery_type === 3"
                />
              </div>
              <van-popup v-model.trim="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
              <p v-if="logistStatus" class="error-message">{{ $t('payBefore.errorMessage.logisticsMode') }}</p>
              <!-- 第二种：寄送或者自取方式 -->
            </div>
            <!-- 指定寄送方式 -->
            <div class="logistics_center_right" v-if="delivery_type === 2">
              <p>{{$t('payBefore.expectedDeliveryTime')}}</p>
              <p>{{ delivery_time }}</p>
            </div>
            <!-- 指定寄送方式 -->
          </div>
          <!-- 指定寄送方式 -->
          <div class="logistics_bottom" v-if="delivery_type === 2 || logist === $t('payBefore.logisticsMode.mode3')">
            <el-input
              type="textarea"
              :rows="2"
              :placeholder="$t('payBefore.placeholder.address')"
              v-model.trim="detail"
              @blur="validTextArea">
            </el-input>
            <p v-if="textAreaStatus" class="error-message">{{ $t('payBefore.placeholder.address') }}</p>
            <p v-if="textAreaStatusFormat" class="error-message">{{ $t('payBefore.errorMessage.otherValid') }}</p>
          </div>
          <!-- 指定寄送方式 -->
        </div>
        <!-- pc端物流方式 -->
        <div class="logisticsMode1" v-if="delivery_type === 3 && inputStatus && need_delivery === 1">
          <p class="logistics_top">{{$t('payBefore.logistics')}}</p>
          <div class="logistics_bottom">
            <p>{{$t('payBefore.logisticsMode.title')}}</p>
            <el-select v-model.trim="logist" placeholder="" @change="changeLogistStatus">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <p v-if="logistStatus" class="error-message">{{ $t('payBefore.errorMessage.logisticsMode') }}</p>
            <el-input
              type="textarea"
              :rows="2"
              :placeholder="$t('payBefore.placeholder.address')"
              v-model="detail"
              @blur="validTextArea"
              v-if="logist === 2">
            </el-input>
            <p v-if="textAreaStatus" class="error-message">{{ $t('payBefore.placeholder.address') }}</p>
            <p v-if="textAreaStatusFormat" class="error-message">{{ $t('payBefore.errorMessage.otherValid') }}</p>
          </div>
        </div>
        <!-- pc端物流方式 -->
        <div class="logisticsMode2" v-if="(delivery_type === 1 || delivery_type=== 2) && inputStatus && need_delivery === 1">
          <p class="logistics_top">{{$t('payBefore.logistics')}}</p>
          <div class="logistics_center">
            <div class="logistics_center_left">
              <p>{{$t('payBefore.logisticsMode.title')}}</p>
              <p v-if="delivery_type === 2">{{$t('payBefore.logisticsMode.mode3')}}</p>
              <p v-if="delivery_type === 1">{{$t('payBefore.logisticsMode.mode4')}}</p>
            </div>
            <div class="logistics_center_right" v-if="delivery_type === 2">
              <p>{{$t('payBefore.expectedDeliveryTime')}}</p>
              <p>{{ delivery_time }}</p>
            </div>
          </div>
          <div class="logistics_bottom" v-if="delivery_type === 2">
            <el-input
              type="textarea"
              :rows="2"
              :placeholder="$t('payBefore.placeholder.address')"
              v-model="detail"
              @blur="validTextArea">
            </el-input>
            <p v-if="textAreaStatus" class="error-message">{{ $t('payBefore.placeholder.address') }}</p>
            <p v-if="textAreaStatusFormat" class="error-message">{{ $t('payBefore.errorMessage.otherValid') }}</p>
          </div>
        </div>

        <div class="remarks" v-if="memo">
          <p class="remark">{{$t('payBefore.remarks')}}</p>
          <p class="description">{{ memo }}</p>
        </div>

        <div class="accept">
          <img :src="selectedImage" alt="" class="accept_left" @click="changeSelectStatus">
          <div class="accept_right">
            <p>
              <span>{{$t('payBefore.terms')}}</span>
              <span @click="goToPrivacyPolice" v-if="!inputStatus">{{$t('payBefore.termsLink')}}</span>
              <span @click="dialogVisible = true" v-if="inputStatus">{{$t('payBefore.termsLink')}}</span>
            </p>
          </div>
        </div>

        <div class="bottom_btn" :class="{'appisFixed_button': !inputStatus}">
          <button @click="goToPay()" :disabled="!selected" :class="{'btn_disabled': !selected}">{{$t('payBefore.payNow')}} {{currencyList[link_currency]}}{{ link_amt }}</button>
        </div>

        <div class="bottom_msg" v-if="!inputStatus">
          <span>Solution powered by </span>
          <img src="../../assets/bottom_brand logo.svg" alt="">
        </div>

      </section>
    </div>

    <el-dialog
      :visible.sync="dialogVisible">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('privacyPolicy.head') }}</p>
      </div>
      <div class="content">
        <p class="content_title">{{$t('privacyPolicy.contentTitle')}}</p>

        <p class="title_one title_detail">{{$t('privacyPolicy.title_one')}}</p>
        <p class="content_one">{{$t('privacyPolicy.content_one')}}</p>

        <p class="title_two title_detail">{{$t('privacyPolicy.title_two')}}</p>
        <p class="content_two">{{$t('privacyPolicy.content_two')}}</p>

        <p class="title_three title_detail">{{$t('privacyPolicy.title_three')}}</p>
        <p class="content_three">{{$t('privacyPolicy.content_three')}}</p>

        <p class="title_four title_detail">{{$t('privacyPolicy.title_four')}}</p>
        <p class="content_four">{{$t('privacyPolicy.content_four')}}</p>

        <p class="title_five title_detail">{{$t('privacyPolicy.title_five')}}</p>
        <p class="content_five">{{$t('privacyPolicy.content_five')}}</p>

        <p class="title_six title_detail">{{$t('privacyPolicy.title_six')}}</p>
        <p class="content_six">{{$t('privacyPolicy.content_six')}}</p>

      </div>
      <div slot="footer"></div>
    </el-dialog>

    <div class="bottom_msg_pc" v-if="inputStatus && !fixedBottom">
      <span>Solution powered by</span>
      <img src="../../assets/c_qfpay_pc.svg" alt="">
    </div>
     <div class="bottom_msg_pc" v-if="inputStatus && fixedBottom">
      <span>Solution powered by</span>
      <img src="../../assets/c_qfpay_pc.svg" alt="">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { paramStringify } from '../../utils/sort'
import { currencyMap } from '../../map/currencyMap'
// import sha256 from 'sha256'
export default {
  name: 'payBefore',
  data () {
    return {
      shopname: '',
      logo_url: require('../../assets/mchnt_logo.svg'),
      link_amt: '',
      link_currency: '',
      related_goods: [],
      expire_time: '',
      intend_customer: {},
      customerName: '',
      customerEmail: '',
      delivery_type: '',
      need_delivery: '',
      delivery_time: '',
      link_id: '',
      selected: 1,
      appcode: '',
      selectedImage: require('../../assets/unselected.png'),
      currencyList: currencyMap,
      columns: [this.$t('payBefore.logisticsMode.mode3'), this.$t('payBefore.logisticsMode.mode4')],
      memo: '',
      telephone1: '',
      telephone2: '',
      detail: '',
      address_id: '',
      customer_id: '',
      inputStatus: false, // false为移动端, true为pc端
      telephoneStatus: false,
      telephoneFormat: false,
      nameFormat: false,
      emailStatus: false,
      logist: '',
      logistStatus: false,
      textAreaStatus: false,
      textAreaStatusFormat: false,
      showPicker: false,
      fixedBottom: true,
      dialogVisible: false,
      options: [{
        value: 2,
        label: this.$t('payBefore.logisticsMode.mode3')
      }, {
        value: 1,
        label: this.$t('payBefore.logisticsMode.mode4')
      }]
    }
  },
  created () {
    this.getClientWidth()
  },
  mounted () {
    this.getFixedBottom()
  },
  methods: {
    getPaymentDetail () {
      // axios.get('http://172.100.108.132:8084/remotepay/pay/detail', {
      axios.get(`${location.protocol}//${location.hostname}/remotepay/pay/detail`, {
        params: {
          link_id: this.$route.query.link_id,
          // link_id: '10080',
          format: 'cors'
        }
      }).then(res => {
        const data = res.data
        if (data.respcd === '0000') {
          if (data.data.logo_url) {
            this.logo_url = data.data.logo_url
          }
          this.shopname = data.data.shopname || ''
          this.related_goods = data.data.related_goods
          this.expire_time = data.data.expire_time
          if (this.expire_time) {
            this.expire_time = this.expire_time.substr(0, 10)
          }
          this.intend_customer = data.data.intend_customer || {}
          this.customerName = data.data.intend_customer.name || ''
          this.customerEmail = data.data.intend_customer.email || ''
          this.customer_id = data.data.intend_customer.customer_id || ''
          if (sessionStorage.getItem('name')) {
            this.customerName = sessionStorage.getItem('name')
          }
          if (sessionStorage.getItem('email')) {
            this.customerEmail = sessionStorage.getItem('email')
          }
          if (sessionStorage.getItem('logist')) {
            this.logist = sessionStorage.getItem('logist')
          }
          if (sessionStorage.getItem('detail')) {
            this.detail = sessionStorage.getItem('detail')
          }
          this.selected = data.data.intend_customer.agree_pact || 1
          if (this.selected === 2) {
            this.selected = true
            this.selectedImage = require('../../assets/selected.png')
          } else if (this.selected === 1) {
            this.selected = false
            this.selectedImage = require('../../assets/unselected.png')
          }
          if (this.inputStatus) {
            if (sessionStorage.getItem('telephone1')) {
              this.telephone1 = sessionStorage.getItem('telephone1')
            } else if (sessionStorage.getItem('telephone2')) {
              this.telephone2 = sessionStorage.getItem('telephone2')
            } else if (sessionStorage.getItem('telephone1') && sessionStorage.getItem('telephone2')) {
              this.telephone1 = sessionStorage.getItem('telephone1')
              this.telephone2 = sessionStorage.getItem('telephone2')
            } else if (this.intend_customer.mobile) {
              const index = this.intend_customer.mobile.indexOf('-')
              this.telephone1 = this.intend_customer.mobile.substr(0, index)
              this.telephone2 = this.intend_customer.mobile.substr(index + 1)
            }
          } else {
            if (sessionStorage.getItem('telephone2')) {
              this.telephone2 = sessionStorage.getItem('telephone2')
            } else {
              this.telephone2 = this.intend_customer.mobile || ''
            }
          }
          this.link_amt = data.data.link_amt
          this.link_currency = data.data.link_currency
          this.delivery_type = data.data.delivery_type
          if (this.delivery_type === 2 && this.customer_id) {
            this.getCustomerAddress()
          }
          this.need_delivery = data.data.need_delivery
          this.delivery_time = data.data.delivery_time
          this.link_id = data.data.link_id
          if (this.related_goods.length > 0) {
            for (let i = 0; i < this.related_goods.length; i++) {
              if (this.related_goods[i].price && this.related_goods[i].goods_num) {
                this.$set(this.related_goods[i], 'singTotal', (this.related_goods[i].price * this.related_goods[i].goods_num).toFixed(2))
              }
            }
          }
          this.appcode = data.data.pay.code
          this.memo = data.data.memo
        } else {
          this.$message.error(data.respmsg)
        }
      })
    },
    getCustomerInfo () {
      let mobile
      if (this.inputStatus) {
        mobile = this.telephone1 + '-' + this.telephone2
      } else {
        mobile = this.telephone2
      }
      // axios.get('http://172.100.108.132:8084/remotepay/customer/info', {
      axios.get(`${location.protocol}//${location.hostname}/remotepay/customer/info`, {
        params: {
          mobile: mobile,
          customer_id: this.customer_id,
          format: 'cors'
        }
      }).then(res => {
        const data = res.data
        if (data.respcd === '0000') {
          if (this.customerName === '') {
            if (data.data.name) {
              this.customerName = data.data.name
            } else {
              this.customerName = ''
            }
          }
          if (this.customerEmail === '') {
            if (data.data.email) {
              this.customerEmail = data.data.email
            } else {
              this.customerEmail = ''
            }
          }
          this.customer_id = data.data.customer_id
          if (this.customer_id && this.delivery_type === 2) {
            this.getCustomerAddress()
          }
        } else {
          this.$message.error(data.respmsg)
        }
      })
    },
    getCustomerAddress () {
      // axios.get('http://172.100.108.132:8084/remotepay/customer/address', {
      axios.get(`${location.protocol}//${location.hostname}/remotepay/customer/address`, {
        params: {
          customer_id: this.customer_id,
          format: 'cors'
        }
      }).then(res => {
        const data = res.data
        if (data.respcd === '0000') {
          this.address_id = data.data.default.address_id
          if (this.detail) {
            return false
          }
          this.detail = data.data.default.detail
        } else {
          this.$message.error(data.respmsg)
        }
      })
    },
    validTelephone () {
      const val1 = this.telephone1
      const val2 = this.telephone2
      if (this.inputStatus) {
        if (((val1 === '' || val1 === null) && val2 !== '') || (val1 !== '' && val1 !== null && val2 === '')) {
          this.telephoneStatus = true
          this.telephoneFormat = false
        } else if (val1 !== '' && val2 !== '') {
          this.telephoneStatus = false
          if (this.telephoneStatus) {
            return
          }
          if (!/^[0-9]*$/.test(val1) || !/^[0-9]*$/.test(val2) || !/^\d{1,3}$/.test(val1)) {
            this.telephoneFormat = true
          } else {
            this.telephoneFormat = false
          }
        } else if ((val1 === '' || val1 === null) && val2 === '') {
          this.telephoneStatus = false
          this.telephoneFormat = false
        }
      } else {
        if (val2 === '') {
          this.telephoneFormat = false
        } else {
          if (/^\d{1,3}-\d{1,20}?$/.test(val2)) {
            this.telephoneFormat = false
          } else {
            this.telephoneFormat = true
          }
        }
      }
    },
    validName () {
      const val = this.customerName
      if (val === '') {
        this.nameFormat = false
      } else {
        if ((/[^\u4e00-\u9fa5_a-zA-Z 0-9()-]/g).test(val)) {
          this.nameFormat = true
        } else {
          this.nameFormat = false
        }
      }
    },
    validEmail () {
      const val = this.customerEmail
      if (val !== '') {
        if (/^([a-zA-Z0-9_-]\.?)+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val)) {
          this.emailStatus = false
        } else {
          this.emailStatus = true
        }
      } else {
        this.emailStatus = false
      }
    },
    validTextArea () {
      const val = this.detail
      if (val === '') {
        this.textAreaStatus = true
        this.textAreaStatusFormat = false
      } else {
        this.textAreaStatus = false
        if ((/[^\u4e00-\u9fa5_a-zA-Z 0-9()\n\-,，/'&()（）;。、.\\]/g).test(val)) {
          this.textAreaStatusFormat = true
        } else {
          this.textAreaStatusFormat = false
        }
      }
    },
    getClientWidth () {
      if (document.body.clientWidth > 900) {
        this.inputStatus = true
      } else {
        this.inputStatus = false
      }
      this.getPaymentDetail()
    },
    getFixedBottom () {
      if (document.documentElement.scrollHeight <= window.innerHeight) {
        this.fixedBottom = true
      } else {
        this.fixedBottom = false
      }
    },
    changeSelectStatus () {
      this.selected = !this.selected
      if (this.selected) {
        this.selectedImage = require('../../assets/selected.png')
      } else {
        this.selectedImage = require('../../assets/unselected.png')
      }
    },
    changeLogistStatus () {
      if (this.logist !== '') {
        this.logistStatus = false
        if (this.logist === 2) {
          this.getCustomerAddress()
        }
        if (this.logist === 1) {
          this.address_id = ''
        }
      }
    },
    onConfirm (value) {
      if (value !== '') {
        this.logistStatus = false
        if (value === this.$t('payBefore.logisticsMode.mode3')) {
          this.getCustomerAddress()
        }
        if (value === this.$t('payBefore.logisticsMode.mode4')) {
          this.address_id = ''
        }
      }
      this.logist = value
      this.showPicker = false
    },
    goToPrivacyPolice () {
      window.sessionStorage.setItem('telephone1', this.telephone1)
      window.sessionStorage.setItem('telephone2', this.telephone2)
      window.sessionStorage.setItem('name', this.customerName)
      window.sessionStorage.setItem('email', this.customerEmail)
      if (this.logist) {
        window.sessionStorage.setItem('logist', this.logist)
      }
      if (this.detail) {
        window.sessionStorage.setItem('detail', this.detail)
      }
      this.$router.push({ name: 'privacyPolice', query: { link_id: this.$route.query.link_id } })
    },
    goToPay () {
      // 移动端只有telephone2
      if (!this.inputStatus) {
        if (this.telephone2) {
          if (!/^\d{1,3}-\d{1,20}?$/.test(this.telephone2)) {
            this.telephoneFormat = true
          } else {
            this.telephoneFormat = false
          }
        }
      } else {
        if (this.telephone1 && this.telephone2) {
          if (!/^[0-9]*$/.test(this.telephone1) || !/^[0-9]*$/.test(this.telephone2) || !/^\d{1,3}$/.test(this.telephone1)) {
            this.telephoneFormat = true
          } else {
            this.telephoneFormat = false
          }
        }
      }
      if (this.logist === '' && this.delivery_type === 3) {
        this.logistStatus = true
        return false
      }
      if (this.logist === 2 && this.delivery_type === 3 && this.detail === '') {
        this.textAreaStatus = true
        return false
      }
      if (this.delivery_type === 2 && this.detail === '') {
        this.textAreaStatus = true
        return false
      }
      if (this.telephoneFormat) {
        return false
      }
      if (this.telephoneStatus) {
        return false
      }
      if (this.emailStatus) {
        return false
      }
      if (this.nameFormat) {
        return false
      }
      if (this.textAreaStatusFormat) {
        return false
      }
      if (!this.logistStatus && !this.telephoneFormat) {
        let mobile
        if (this.inputStatus) {
          if (this.telephone1 && this.telephone2) {
            mobile = this.telephone1 + '-' + this.telephone2
          } else {
            mobile = ''
          }
        } else {
          mobile = this.telephone2
        }
        let deliveryType
        if (this.logist === 1 || this.logist === this.$t('payBefore.logisticsMode.mode4') || this.delivery_type === 1) {
          deliveryType = 1
        } else if (this.logist === 2 || this.logist === this.$t('payBefore.logisticsMode.mode3') || this.delivery_type === 2) {
          deliveryType = 2
        }
        const params = {
          link_id: this.link_id,
          name: this.customerName,
          mobile: mobile,
          memo: this.memo,
          email: this.customerEmail,
          delivery_type: deliveryType,
          detail: this.detail,
          agree_pact: this.selected ? 2 : 1,
          customer_id: this.customer_id,
          address_id: this.address_id,
          return_url: `${location.protocol}//${location.hostname}/remotepay/pay/pay_result`,
          failed_url: `${location.protocol}//${location.hostname}/remotepay/pay/pay_result`,
          format: 'cors'
        }
        // axios.post('http://172.100.113.34:6510/remotepay/pay/do_order', qs.stringify(params))
        axios.post(`${location.protocol}//${location.hostname}/remotepay/pay/do_order`, qs.stringify(params))
          .then(res => {
            const data = res.data
            if (data.respcd === '0000') {
              window.sessionStorage.removeItem('telephone1')
              window.sessionStorage.removeItem('telephone2')
              window.sessionStorage.removeItem('name')
              window.sessionStorage.removeItem('email')
              if (window.sessionStorage.getItem('logist')) {
                window.sessionStorage.removeItem('logist')
              }
              if (window.sessionStorage.getItem('detail')) {
                window.sessionStorage.removeItem('detail')
              }
              const pamData = data.data.pay
              const host = location.hostname.replace('item', 'openapi')
              window.location.href = `${location.protocol}//${host}/checkstand/#/?${paramStringify(pamData, true)}`
              // window.location.href = `https://openapi-hk.qfapi.com/checkstand/#/?${paramStringify(pamData, true)}`
              // window.location.href = `https://openapi-int.qfapi.com/checkstand/#/?${paramStringify(pamData, true)}`
            } else {
              this.$message.error(data.respmsg)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
  @media only screen and (max-width: 900px) {
    .payBefore {
      background: url('../../assets/bg.svg') no-repeat;
      background-color: #F7F7F7;
      background-size: contain;
      width: 100%;
      header {
        width: 100%;
        height: 44.69px;
        line-height: 44.69px;
        text-align: center;
        color: #FFFFFF;
        font-size: 17px;
      }
      section {
        margin: 5px 15px 0 15px;
        padding-bottom: 113px;
        .product-card {
          background-color: #FFFFFF;
          padding: 19px 15px 0 15px;
          box-shadow:0px 2px 9px 0px rgba(130,130,130,0.1);
          .product-card_top {
            border-bottom: 1px dashed #A7A9AE;
            .shopName {
              height: 25px;
              line-height: 25px;
              img {
                height: 25px;
                width: 25px;
                border-radius: 25px;
                vertical-align: bottom;
                border:1px solid rgba(229,229,229,1);
              }
              span {
                margin-left: 10px;
                font-size: 15px;
                color: #000000;
                line-height: 15px;
              }
            }
            .totalPrice {
              margin-top: 24px;
              text-align: center;
              .totalPrice_currency {
                font-size: 13px;
                color: #606470;
              }
              .totalPrice_number {
                color: #000000;
                span:nth-child(1) {
                  font-size: 15px;
                }
                span:nth-child(2) {
                  font-size: 30px;
                }
              }
            }
            .product-detail {
              margin-top: 36px;
              .product-detail_message {
                font-size: 15px;
                height: 35px;
                p:nth-child(1) {
                  float: left;
                }
                p:nth-child(2) {
                  float: right;
                }
                p:nth-child(3) {
                  float: right;
                  margin-right: 20px;
                }
              }
            }
          }
          .product-card_bottom {
            height: 45px;
            line-height: 45px;
            p:nth-child(1) {
              float: left;
              color: #606470;
              font-size: 15px;
            }
            p:nth-child(2) {
              float: right;
              color: #000000;
              font-size: 15px;
            }
          }
        }
        .customer-information {
          padding: 20px 15px 15px 15px;
          background-color: #FFFFFF;
          box-shadow:0px 2px 9px 0px rgba(130,130,130,0.1);
          margin-top: 10px;
          .information {
            color: #2A2B2C;
            font-size: 15px;
            font-weight:500;
          }
          .telephone, .email, .name {
            margin-top: 20px;
            font-size: 15px;
            display: flex;
            label {
              color: #606470;
              padding: 3px;
              width: 25%;
            }
            .error-message {
              color: #F15F5D;
              right: 0;
              font-size: 12px;
              text-align: right;
            }
            .flex-row {
              width: 75%;
              display: flex;
              flex-direction: column;
            }
          }
          input {
            padding: 5px;
            width: calc(100%-10px);
            height: 15px;
            text-align: right;
            overflow-x: scroll;
            outline-style: none;
            border: none;
          }
          .someTips {
            height: 55px;
            margin-top: 16px;
            padding: 9px 15px 10px 15px;
            background-color: #F7F7F7;
            color: #606470;
            font-size: 13px;
            box-sizing: border-box;
          }
          .emailExtendHeight {
            margin-top: 25px;
          }
        }
        .logistics {
          margin-top: 10px;
          box-shadow:0px 2px 9px 0px rgba(130,130,130,0.1);
          padding: 20px 15px;
          background: #FFFFFF;
          box-sizing: border-box;
          .logistics_top {
            color: #2A2B2C;
            font-size: 15px;
            height: 15px;
            font-weight: 500;
            line-height: 15px;
          }
          .logistics_center {
            .logistics_center_left, .logistics_center_right {
              display: flex;
              flex-direction: column;
              font-size: 15px;
              line-height: 15px;
              margin-top: 15px;
              p:nth-child(1) {
                color: #606470;
              }
              p:nth-child(2) {
                color: #000000;
                margin-top: 15px;
              }
            }
            .logistics_center_left {
              .flex-row {
                display: flex;
                justify-content: space-between;
                .flex-column {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                }
              }
              .van-field {
                background: url('../../assets/right-select.svg') no-repeat center right;
                background-size: 6px 11px;
                width: 100px;
                height: 20px;
                font-size: 15px;
                line-height: 15px;
                padding: 0;
                .van-field__control {
                  border: none;
                }
              }
              .error-message {
                font-size: 12px;
                color: #F15F5D;
                position: absolute;
                right: 0;
                bottom: -15px;
              }
            }
          }
          .logistics_bottom {
            margin-top: 20px;
            height: 88px;
            .el-textarea {
              border-radius: 3px;
              border: 1px solid rgba(229,229,229,1);
              .el-textarea__inner {
                height: 88px;
                border: none;
                padding: 15px 15px;
              }
            }
            .error-message {
              font-size: 12px;
              height: 12px;
              line-height: 12px;
              color: #F15F5D;
              margin-top: 8px;
            }
          }
        }
        .extendLogistics {
          padding-bottom: 35px;
        }
        .remarks {
          padding: 20px 15px;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow:0px 2px 9px 0px rgba(130,130,130,0.1);
          margin-top: 10px;
          .remark {
            height: 15px;
            color: #000000;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 15px;
          }
          .description {
            font-size: 15px;
            line-height: 20px;
            color: #606470;
          }
        }
        .accept {
          height: 54px;
          margin-top: 15px;
          display: flex;
          .accept_left {
            margin-top: 2px;
            height: 15px;
            width: 15px;
            vertical-align: bottom;
          }
          .accept_right {
            height: 54px;
            width: 325px;
            font-size: 13px;
            margin-left: 7px;
            p {
              span:nth-child(2) {
                color: #FF8100;
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
        .bottom_btn {
          margin-top: 25px;
          border-radius:8px;
          height: 50px;
          border: none;
          button {
            border: none;
            color: #FFFFFF;
            font-size: 17px;
            line-height: 50px;
            background-color: #FF8100;
            border-radius:8px;
            padding: 0;
            width: 100%;
          }
          .btn_disabled {
            background-color: #A7A9AE;
          }
        }
        .bottom_msg {
          position: fixed;
          left: 0;
          bottom: 0;
          padding-top: 10px;
          padding-bottom: 15px;
          width: 100%;
          text-align: center;
          font-size: 13px;
          height: 13px;
          line-height: 13px;
          background-color: #f7f7f7;
          img {
            vertical-align: middle;
            width: 48.9px;
            height: 12.87px;
          }
        }
      }
      .appisFixed_button {
        width: 100%;
        box-sizing: border-box;
        padding-left: 15px;
        padding-right: 15px;
        position: fixed;
        bottom: 38px;
        left: 0;
        background-color: #f7f7f7;
      }
    }
  }
  @media only screen and (min-width: 900px) {
    .payBefore {
      background: url('../../assets/bg_pc.png') no-repeat;
      background-color: #F7F7F7;
      background-size: contain;
      .main_wraper {
        width: 900px;
        margin: 0 auto;
        header {
          padding-top: 47px;
          color: #FFFFFF;
          font-size: 32px;
          height: 116px;
          box-sizing: border-box;
        }
        section {
          .product-card {
            // height: 410px;
            background-color: #FFFFFF;
            padding: 30px 30px 0 30px;
            border-radius:10px;
            box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
            .product-card_top {
              // height: 344px;
              .shopName {
                height: 40px;
                line-height: 40px;
                img {
                  height: 40px;
                  width: 40px;
                  border-radius: 40px;
                  vertical-align: bottom;
                  border:1px solid rgba(229,229,229,1);
                }
                span {
                  margin-left: 12px;
                  font-size: 18px;
                  color: #000000;
                  line-height: 18px;
                }
              }
              .totalPrice {
                margin-top: 30px;
                text-align: right;
                padding-bottom: 26px;
                border-bottom: 1px dashed #A7A9AE;
                .totalPrice_currency {
                  font-size: 14px;
                  color: #606470;
                }
                .totalPrice_number {
                  margin-top: 10px;
                  color: #000000;
                  font-size: 30px;
                  font-weight:600;
                }
              }
              .product-detail {
                .product-detail_message {
                  height: 80px;
                  line-height: 80px;
                  font-size: 16px;
                  border-bottom: 1px dashed #A7A9AE;
                  p:nth-child(1) {
                    float: left;
                    color: #2F323A;
                  }
                  p:nth-child(2) {
                    float: right;
                    color: #000000;
                  }
                  p:nth-child(3) {
                    float: right;
                    margin-right: 70px;
                    color: #000000;
                  }
                  p:nth-child(4) {
                    float: right;
                    margin-right: 70px;
                    color: #000000;
                  }
                }
              }
            }
            .product-card_bottom {
              height: 66px;
              line-height: 66px;
              font-size: 16px;
              p:nth-child(1) {
                float: left;
                color: #606470;
                margin-right: 10px;
              }
              p:nth-child(2) {
                float: left;
                color: #000000;
              }
            }
          }
          .customer-information {
            position: relative;
            padding: 30px 30px 0px 30px;
            background-color: #FFFFFF;
            box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
            border-radius:10px;
            margin-top: 10px;
            height: 176px;
            .information {
              color: #424242;
              font-size: 18px;
              font-weight:600;
            }
            .telephone, .email, .name {
              position: relative;
              margin-top: 20px;
              height: 62px;
              float: left;
              width: 266px;
              color: #2F323A;
              font-size: 14px;
              margin-right: 20px;
              label {
                display: block;
                margin-bottom: 12px;
                height: 14px;
              }
              input {
                height: 32px;
                width: 246px;
                padding-left: 12px;
                border:1px solid rgba(194,194,194,1);
                border-radius:3px;
              }
              .error-message {
                color: #F15F5D;
                position: absolute;
                left: 10px;
                bottom: -22px;
                font-size: 13px;
                white-space: pre;
              }
            }
            .email {
              color: #606470;
              margin-right: 0;
            }
            .telephone, .name {
              label {
                margin-left: 10px;
              }
            }
            .telephone {
              width: 268px;
              position: relative;
              &::after {
                content: '+';
                color: #262424;
                font-size: 14px;
                position: absolute;
                left: 12px;
                bottom: 10px;
              }
              .error-message {
                color: #F15F5D;
                position: absolute;
                left: 80px;
                bottom: -22px;
                font-size: 13px;
              }
              input:nth-child(2) {
                padding-left: 22px;
                width: 34px;
                margin-right: 10px;
              }
              input:nth-child(3) {
                width: 174px;
              }
            }
            .someTips {
              position: absolute;
              right: 30px;
              bottom: 30px;
              height: 36px;
              width: 254px;
              color: #606470;
              font-size: 13px;
            }
          }
          .logisticsMode1 {
            margin-top: 10px;
            // height: 160px;
            box-sizing: border-box;
            padding-left: 30px;
            padding-top: 30px;
            padding-bottom: 30px;
            background-color: #FFFFFF;
            box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
            border-radius:10px;
            .logistics_top {
              color: #424242;
              font-size: 18px;
              font-weight:600;
              height: 18px;
              line-height: 18px;
              margin-bottom: 20px;
            }
            .logistics_bottom {
              p:nth-child(1) {
                color: #606470;
                font-size: 14px;
                height: 14px;
                line-height: 14px;
                &::before {
                  content: '*';
                  color: #E73B48;
                  margin-right: 5px;
                }
              }
              .el-select {
                margin-top: 12px;
                height: 36px;
                width: 266px;
                .el-input {
                  height: 36px;
                  .el-input__inner {
                    height: 36px;
                    padding-left: 10px;
                    border-color: #C2C2C2;
                  }
                  .el-input__suffix {
                    .el-input__icon {
                      line-height: 36px !important;
                    }
                  }
                }
              }
              .error-message {
                color: #F15F5D;
                margin-top: 5px;
                font-size: 13px;
              }
              .el-textarea {
                margin-top: 24px;
                height: 66px;
                width: 840px;
                border-radius:3px;
                border:1px solid rgba(194,194,194,1);
                .el-textarea__inner {
                  height: 66px;
                  border: none;
                  padding: 15px 12px;
                }
              }
            }
          }
          .logisticsMode2 {
            margin-top: 10px;
            // height: 248px;
            box-sizing: border-box;
            padding-left: 30px;
            padding-top: 28px;
            padding-bottom: 30px;
            background-color: #FFFFFF;
            box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
            border-radius:10px;
            .logistics_top {
              height: 25px;
              font-size: 18px;
              font-weight: 600;
              line-height: 25px;
              color: #424242;
            }
            .logistics_center {
              margin-top: 21px;
              height: 54px;
              .logistics_center_left, .logistics_center_right {
                float: left;
                p:nth-child(1) {
                  color: #606470;
                  font-size: 14px;
                  height: 14px;
                  line-height: 14px;
                  margin-bottom: 18px;
                }
                p:nth-child(2) {
                  color: #000000;
                  height: 22px;
                  line-height: 22px;
                  font-size: 16px;
                }
              }
              .logistics_center_left {
                width: 266px;
                margin-right: 34px;
                padding-left: 12px;
                box-sizing: border-box;
              }
              .logistics_center_right {
                width: 184px;
              }
            }
            .logistics_bottom {
              margin-top: 24px;
              height: 66px;
              width: 840px;
              .el-textarea {
                border-radius:3px;
                border:1px solid rgba(194,194,194,1);
                .el-textarea__inner {
                  height: 66px;
                  border: none;
                  padding: 15px 12px;
                }
              }
              .error-message {
                color: #F15F5D;
                margin-top: 5px;
                font-size: 13px;
                margin-left: 12px;
              }
            }
          }
          .remarks {
            padding: 30px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow:0px 7px 20px 0px rgba(0,0,0,0.05);
            border-radius:10px;
            margin-top: 10px;
            .remark {
              height: 18px;
              color: #424242;
              font-size: 18px;
              line-height: 18px;
              font-weight: 600;
              margin-bottom: 20px;
            }
            .description {
              font-size: 16px;
              line-height: 25px;
              color: #606470;
            }
          }
          .accept {
            float: left;
            height: 48px;
            margin-top: 30px;
            .accept_left {
              margin-top: 4px;
              float: left;
              height: 16px;
              width: 16px;
              vertical-align: bottom;
              margin-right: 9px;
            }
            .accept_right {
              float: left;
              height: 48px;
              width: 587px;
              font-size: 16px;
              line-height: 24px;
              p {
              span:nth-child(2) {
                color: #FF8100;
                &:hover {
                  cursor: pointer;
                }
              }
            }
            }
          }
          .bottom_btn {
            cursor: pointer;
            float: right;
            margin-top: 30px;
            border-radius:8px;
            height: 50px;
            width: 250px;
            background:rgba(255,129,0,1);
            text-align: center;
            button {
              border: none;
              color: #FFFFFF;
              border-radius:8px;
              font-size: 17px;
              width: 250px;
              height: 50px;
              line-height: 50px;
              background:rgba(255,129,0,1);
            }
            .btn_disabled {
              background-color: #A7A9AE;
            }
          }
        }
      }
      .el-dialog__wrapper {
        .el-dialog {
          background: none;
          border: none;
          box-shadow: none;
          width: 683px;
          height:611px;
          box-sizing: border-box;
          background:#FFFFFF;
          box-shadow:0px 0px 6px 0px rgba(0,0,0,0.04),0px 2px 4px 0px rgba(0,0,0,0.12);
          border-radius:2px;
          .el-dialog__header {
            padding: 30px 30px 26px;
            font-size: 20px;
            color: #282B2D;
            height: 20px;
            line-height: 20px;
          }
          .el-dialog__body {
            height: 505px;
            padding: 0 30px 0px 30px;
            overflow-y: scroll;
            .content {
              height: 505px;
              font-size: 14px;
              line-height: 24px;
              color: #606470;
              white-space: pre-line;
              p {
                margin-bottom: 6px;
              }
              .title_detail {
                margin-top: 10px;
                margin-bottom: 4px;
                font-size: 15px;
                font-weight: 500;
                color: #2A2B2C
              }
            }
          }
        }
      }
      .bottom_msg {
        margin-top: 10px;
        margin-bottom: 15px;
        text-align: center;
        font-size: 13px;
        img {
          vertical-align: middle;
          width: 48.9px;
          height: 12.87px;
        }
      }
      .bottom_msg_pc {
        margin-top: 132px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #464646;
        color: #FFFFFF;
        span {
          margin-top: 22px;
          line-height: 16px;
          display: inline-block;
          height: 16px;
          margin-right: 8px;
          font-size: 14px;
        }
        img {
          width: 81px;
          height: 15px;
          vertical-align: middle;
        }
      }
      .bottom_msg_pc_fixed {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #464646;
        color: #FFFFFF;
        span {
          margin-top: 22px;
          line-height: 16px;
          display: inline-block;
          height: 16px;
          margin-right: 8px;
          font-size: 14px;
        }
        img {
          width: 81px;
          height: 15px;
          vertical-align: middle;
        }
      }
    }
  }
</style>
